import { BareActionContext } from 'vuex-typex'
import { StatementState } from '../state'
import { RootState } from '../..'
import { StatementService } from '../../../service/StatementService'
import { IStatement } from '../../../model/statement'
import statementStore from '../statement-store'
import statementUtils from './statement-utils'
import fetchTags from './fetch-tags'

export default async function removeStatementTag(context: BareActionContext<StatementState, RootState>, payload: { statement: IStatement, tag: string })
{
    statementUtils.statementService.removeTag(payload.statement, payload.tag).then((result: any) => {
        fetchTags(context, payload.statement)
    })

    return
}
